import React, { useState } from 'react';

import { COLORS } from '@clutter/clean';
import { Box, Text } from '@clutter/clean';

import { PasswordForm } from '@portal/components/password/password_form';
import { CUSTOMER_POST_BOOKING_SIGN_IN } from '@portal/config/customer';
import { wt } from '@portal/initializers/wt';
import { client } from '@portal/libraries/apollo';
import { Status, usePasswordSetupMutation } from '@portal/schema';

export const PasswordCreateForm: React.FC<{
  token: string;
  onSave(): void;
}> = ({ token, onSave }) => {
  const [execute, { loading, data }] = usePasswordSetupMutation({ client });
  const error = data?.result?.error;

  const save = async ({ password }: { password: string }) => {
    const response = await execute({
      variables: {
        input: {
          token,
          password,
        },
      },
    });

    const status = response.data?.result?.status;
    if (status === Status.Ok) {
      onSave();
      trackSetPasswordClick(true);
    } else {
      trackSetPasswordClick(false);
    }
  };

  return (
    <>
      <PasswordForm error={error} loading={loading} buttonText="Set Password" save={save} />

      {!CUSTOMER_POST_BOOKING_SIGN_IN && (
        <Box textAlign="center" margin="24px 0 0">
          <Text.Callout color={COLORS.storm}>
            By clicking Set Password, I agree to Clutter’s{' '}
            <a style={{ textDecoration: 'underline' }} href="https://www.clutter.com/legal/tos" target="_blank">
              Terms of Use.
            </a>
          </Text.Callout>
        </Box>
      )}
    </>
  );
};

function trackSetPasswordClick(successful: boolean) {
  const params = {
    pageName: 'portal:password:create',
    container: 'password_create',
    action: 'click',
    objectType: 'button',
    objectName: 'set_password_button',
    label: 'Set Password',
    value: successful,
  };

  wt.track(params);
}
